import { UniversalCard } from '@components/core-ui/UniversalCard';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Link } from 'react-router-dom';
import { TTeamCardItem } from './types/TTeamCardItem';

type TProps = {
  team: TTeamCardItem;
  handleDeleteTeam: (team: TTeamCardItem) => void;
};

export const TeamCard = ({ team, handleDeleteTeam }: TProps) => {
  const { organization } = useAuthContext();

  const actions: Array<{ label: string; link?: string; className?: string; onClick?: () => void }> = [
    { label: 'Details', link: routes.teamDetails.make(organization?.slug ?? '', team?.slug) },
    { label: '', className: 'divider' },
    { label: 'Delete', className: 'red', onClick: () => handleDeleteTeam(team) },
  ];
  if (team?.default || team?.owner) {
    actions.pop();
    actions.pop();
  }

  const content = (
    <>
      <Link
        to={routes.teamDetails.make(organization?.slug ?? '', team?.slug)}
        className="font-medium text-[var(--color-title)] hover:text-foreground-muted"
      >
        {team?.name || team?.slug}
      </Link>
      <p>&nbsp;</p>
      {team?.members !== undefined ? (
        <p className="text-foreground-muted text-xs">
          {team?.members} {team?.members === 1 ? 'member' : 'members'}
        </p>
      ) : null}
    </>
  );

  return (
    <UniversalCard
      backgroundColor={team?.colour}
      content={content}
      name={team?.name || team?.slug || ''}
      actions={actions}
    />
  );
};
